import { cn } from "@fronterahealth/frontera-ui-components/lib/utils";
import { Input } from "@fronterahealth/frontera-ui-components/ui/input";

import { ReportFieldInputProps } from "@components/ReportField/types";

export const ReportFieldTypedSignature: React.FC<ReportFieldInputProps> = ({
  id,
  value,
  onChange,
  variant,
  onFocus,
  disabled,
  onBlur,
  className,
  ariaInvalid,
}) => {
  if (disabled) {
    if (!value)
      return (
        <div className="flex flex-col items-start pt-8 pb-2">
          <div className="w-64 border-b-2 border-black" />
        </div>
      );
    return (
      <div
        className={cn(
          `typed-signature-field -mt-2 -mb-2 bg-limestone-50 rounded-lg p-4 border border-limestone-100`,
          className,
        )}
      >
        {value}
      </div>
    );
  }
  return (
    <div
      className={cn(
        `typed-signature-field -mt-2 -mb-2 bg-limestone-50 rounded-lg p-4 border border-limestone-100`,
        className,
      )}
    >
      <Input
        id={id}
        className={cn(
          // `bg-white`,
          variant !== "ghost" && "bg-white",
          variant === "ghost" && "group-hover/field:bg-white group-focus-within/field:bg-white",
        )}
        variant={variant}
        value={value ?? ""}
        placeholder="Enter signature"
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        aria-invalid={ariaInvalid}
      />
    </div>
  );
};
